interface PriceChangeBadgeProps {
  x: number;
  y: number;
  pct: number;
}

const CHAR_WIDTH = 6.5;
const PAD_X = 6;
const PAD_Y = 3;
const HEIGHT = 18;
const OFFSET_FROM_POINT = 6;

export function PriceChangeBadge({ x, y, pct }: PriceChangeBadgeProps) {
  const text = `${pct > 0 ? '+' : ''}${pct.toFixed(1)}%`;
  const width = text.length * CHAR_WIDTH + PAD_X * 2;
  // Sit above the point on price increases, below on decreases — keeps the
  // badge on the opposite side of the line's slope into that point, so it
  // never crosses the line.
  const offsetY = pct < 0 ? OFFSET_FROM_POINT : -HEIGHT - OFFSET_FROM_POINT;
  return (
    <g transform={`translate(${x - width / 2}, ${y + offsetY})`}>
      <rect
        width={width}
        height={HEIGHT}
        rx={4}
        fill="var(--primary-800, #08314c)"
      />
      <text
        x={width / 2}
        y={HEIGHT / 2 + PAD_Y}
        fill="white"
        fontSize={11}
        fontWeight={600}
        textAnchor="middle"
      >
        {text}
      </text>
    </g>
  );
}
